import { SCHOOL_HEADER } from '@rythmo/shared';
import createClient from 'openapi-fetch';
import { ApiProblem } from './problem.js';
/** `https://<label>.<api domain>`, the one place a service's host is spelled. */
export function serviceUrl(label, apiDomain) {
    return `https://${label}.${apiDomain}`;
}
export function createApiClient(options) {
    const middleware = {
        async onRequest({ request }) {
            const token = await options.getToken();
            if (token)
                request.headers.set('authorization', `Bearer ${token}`);
            const school = await options.getSchool?.();
            if (school)
                request.headers.set(SCHOOL_HEADER, school);
            return request;
        },
    };
    const send = options.fetch ?? ((request) => globalThis.fetch(request));
    async function fetchOrThrow(request) {
        const response = await send(request);
        if (!response.ok)
            throw await ApiProblem.from(response);
        return response;
    }
    function clientFor(label) {
        const client = createClient({
            baseUrl: options.baseUrl?.(label) ?? serviceUrl(label, options.apiDomain),
            fetch: fetchOrThrow,
        });
        client.use(middleware);
        return client;
    }
    return {
        gateway: clientFor('gateway'),
        tenant: clientFor('tenant'),
        catalog: clientFor('catalog'),
        billing: clientFor('billing'),
        booking: clientFor('booking'),
        notification: clientFor('notification'),
    };
}
//# sourceMappingURL=client.js.map